import Option from './Option/Option';

function Options({
    filteredOptions,
    value,
    getInputValue,
    hasAlerts,
    onSelect,
    selectedOptionIndex,
    setSelectedOptionIndex,
    inputValue,
    onChange,
    setDropdownOpened,
    setInputValue,
    setReferenceValue,
    referenceExpr,
    isInventoryProperty,
    fieldName,
    isClientEquipmentEnabled,
}) {
    return (
        <>
            {filteredOptions.map((option, i) => {
                const key = option.duplicate ? getInputValue(option) + ' dropdownOptionLabelDuplicate' + option.duplicate : getInputValue(option);
                // Props are passed explicitly rather than spread: a `{...props}`
                // spread re-passes unstable values (and the whole filteredOptions
                // array) into every row, which defeats Option's memoization.
                return (
                    <Option
                        key={i + '_' + key}
                        optionIndex={i}
                        option={option}
                        activeOption={option === value}
                        selectedOption={selectedOptionIndex === i}
                        setSelectedOptionIndex={setSelectedOptionIndex}
                        hasAlerts={hasAlerts}
                        onSelect={onSelect}
                        inputValue={inputValue}
                        onChange={onChange}
                        setDropdownOpened={setDropdownOpened}
                        setInputValue={setInputValue}
                        setReferenceValue={setReferenceValue}
                        referenceExpr={referenceExpr}
                        isInventoryProperty={isInventoryProperty}
                        fieldName={fieldName}
                        isClientEquipmentEnabled={isClientEquipmentEnabled}
                        getInputValue={getInputValue}
                    />
                );
            })}
        </>
    );
}

export default Options;

//TODO  disabling eslint warining for now, export function to separate file
// eslint-disable-next-line react-refresh/only-export-components
export const focusNextInputField = function (currentInputFieldId) {
    const inputToFocus = document.getElementById(`${+currentInputFieldId + 1}`);
    inputToFocus && setTimeout(() => inputToFocus.focus(), 0);
};
